// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"RemoveEntityButton_tooltipWrapper__1EWd7"};